// extracted by mini-css-extract-plugin
module.exports = {"container":"item-select-container_container__4RdfB","itemSelectList":"item-select-container_itemSelectList__1DWCC","fade-in":"item-select-container_fade-in__ElxzY"};